////AlertDialogBase.js

import React from 'react';
import Button from 'src/ui/library/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import styled from 'src/ui/library/styled';
import { Edit /*Warning*/ } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
    maxWidth: '950px',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  closeIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
});

class AlertDialog extends React.Component {
  static propTypes = {};
  render() {
    const { cancelText, children, classes, onCancel, open, title, confirmText, onConfirm, subTitle } = this.props;

    return (
      <Dialog classes={{ root: classes.root, paper: classes.rootPaper }} open={open}>
        <div className={classes.header}>
          <h2 className={classes.title} id="confirm-title">
            {title}
          </h2>
          <div className={classes.closeIcon} onClick={onCancel || null}>
            <CloseIcon />
          </div>
        </div>
        <h3 className={classes.title} id="confirm-title">
          {subTitle}
        </h3>
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
        <div className={classes.divider} />
        <DialogActions classes={{ action: classes.buttonAction }}>
          <a className="link" onClick={onCancel || null} style={{ display: 'inherit', fontSize: '14px', color: 'black' }}>
            <Edit className="icon" />{' '}
            <span className="text" style={{ marginLeft: '10px' }}>
              {cancelText}
            </span>
          </a>
          <Button onClick={onConfirm || null} style={{ marginLeft: '620px' }} noMaxWidth={true} aria-label={confirmText}>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default styled(AlertDialog)(styles);
